export const routerPath = {
  main: '/',
  courses: '/courses',
  courseDetail: '/courses/:id',
  groupDetail: '/courses/:courseId/intakes/:intakeId/groups/:groupNumber',
  termDetail: '/courses/:courseId/intakes/:intakeId/groups/:groupNumber/terms/:termId',
  moduleDetail:
    '/courses/:courseId/intakes/:intakeId/groups/:groupNumber/terms/:termId/modules/:moduleId',
  moduleLessonPreview:
    '/courses/:courseId/intakes/:intakeId/groups/:groupNumber/terms/:termId/modules/:moduleId/lessons/:lessonId/preview',
  sessionAttendance:
    '/courses/:courseId/intakes/:intakeId/groups/:groupNumber/terms/:termId/modules/:moduleId/sessions/:groupLessonId/attendance',
  attendance:
    '/courses/:courseId/intakes/:intakeId/groups/:groupNumber/terms/:termId/attendance/:moduleId',
  active: '/active',
  applicants: '/applicants',
  profiles: '/profiles',
  growthSystem: '/growth-system',
  academicStaff: '/academic-staff',
  administration: '/administration',
  operationsCenter: '/operations-center',
  attributesCategories: '/attributes/categories',
  attributesDifficultyLevels: '/attributes/difficulty-levels',
  attributesHashtags: '/attributes/hashtags',
  assignmentsTest: '/assignments-test',
  assignmentDetail: '/assignments-test/:courseId/:intakeId',
  certificates: '/certificates',
  certificatesCourse: '/certificates/courses/:courseId',
  locations: '/locations',
  locationDetail: '/locations/:id',
  payments: '/payments',
  scheduleEvents: '/schedule-events',
  chats: '/chats',
  community: '/community',
  articlesNews: '/articles/news',
  articlesNewsCreate: '/articles/news/new',
  articlesNewsDetail: '/articles/news/:id',
  articlesNewsEdit: '/articles/news/:id/edit',
  articlesBlog: '/articles/blog',
  articlesBlogCreate: '/articles/blog/new',
  articlesBlogDetail: '/articles/blog/:id',
  articlesBlogEdit: '/articles/blog/:id/edit',
  careerHub: '/career-hub',
  pushNotifications: '/push-notifications',
  // Личные уведомления пользователя (колокольчик в шапке), не рассылки админки
  myNotifications: '/notifications',
  requestsReports: '/requests-reports',
  settings: '/settings',
  logout: '/logout',
  login: '/login',
  forgotPassword: '/forgot-password',
  resetPassword: '/reset-password',
  setPassword: '/set-password',
  not_found: '*',
} as const;

export type TypeRouterPath = (typeof routerPath)[keyof typeof routerPath];
